export enum NetworkLogsCommunicationDirectionEnum {
  chargingStationToCsms = 'chargingStationToCsms',
  csmsToChargingStation = 'csmsToChargingStation',
}
